import Block from './Block';

class BlockFactory {
	static getDisplayBlockTypeName(blockType) {
		if (blockType === Block.TYPE_IMAGE) {
			return "이미지 블럭";
		}
		else if (blockType === Block.TYPE_TEXT) {
			return "텍스트 블럭";
		}
		else if (blockType === Block.TYPE_YOUTUBE) {
			return "유튜브 블럭";
		}
    else if (blockType === Block.TYPE_VIDEO) {
      return "비디오 블럭";
    }
    else if (blockType === Block.TYPE_PDF) {
      return 'PDF 블럭';
    }
		return "알수없는 블럭";
	}

	static getDisplayBlockName(blockName) {
		let tokens = blockName.split('-');
		return BlockFactory.getDisplayBlockTypeName(tokens[0]) + ' ' + tokens[1];
	}

	static createEmpty(blockType, blockName) {
		let blockData = {
			type: blockType,
			name: blockName,
			//backgroundColor: 'white',
			scale: 1,
			translationX: 0,
		};
		return new Block(blockData);
	}

	static create(blockData) {
		return new Block(blockData);
	}

	static clone(block) {
		return new Block(block);
	}

	static async toDipBlock(block, resources) {
/*
		let dataStr = JSON.stringify(block.data);
		console.log("text block data size = " + dataStr.length);

		const SIZE_LIMIT = 10240;		// 10KB

		if (dataStr.length > SIZE_LIMIT) {
			let b = new Block(block);
			b.dipResourceUrl = await global.dipClient.uploadData(b.name, new Buffer(dataStr));
			b.data = undefined;
			return b;
		}
*/
		let b = new Block(block);
		resources[b.name] = block.resources;
		b.resources = undefined;
		return b;
	}

	static async fromDipBlock(block, resources) {
		// patch: auto conversion for legacy
		if (!block.data && block.html) {
			block.data = block.html;
		}
		block.html = undefined;

		if (!block.data && block.videoId) {
			block.data = block.videoId;
		}
		block.videoId = undefined;
		//

		let b = new Block(block);
		b.resources = resources[b.name];

/*
		if (block.dipResourceUrl) {
			try {
				let dataStr = await global.dipClient.downloadData(block.dipResourceUrl);
				b.data = JSON.parse(dataStr);
			}
			catch (e) {
				//b.data = { ops: [] };
			}
			return b;
		}
*/
		return b;
	}
}

export default BlockFactory;
